import React from 'react';
import OrderImport from '../OrderImport';

const OrderImportStaff = () => {
  return <OrderImport />;
};

export default OrderImportStaff;
